import { gsap } from 'gsap'

export default {
	static: true,
	history: false,
	lockBrowserScroll: true,
	closeOnEscape: true,
	closeOnOutsideClick: '.overlay-view__panel',
	backdropSelector: '.js-overlay-backdrop',

	initElements(view) {
		return {
			panel: view.element.querySelector('.overlay-view__panel'),
		}
	},

	// add GSAP open animation here
	onOpen(view) {
		this.elBackdrop = view.backdrop

		console.log('aiaiai')

		const timeline = gsap
			.timeline()
			.fromTo(this.elements.backdrop, { opacity: 0 }, { opacity: 1, duration: 0.3 })
			.fromTo(this.elements.panel, { x: '-100%', opacity: 0 }, { x: '0%', opacity: 1, duration: 0.3, ease: 'power2.out' }, 0)

		return timeline
	},

	// add GSAP close animation here
	onClose(view) {
		console.log('bbb')
		const timeline = gsap
			.timeline()
			.to(this.elements.panel, { x: '-100%', opacity: 0, duration: 0.3, ease: 'power2.in' }, 0)
			.to(this.elements.backdrop, { opacity: 0, duration: 0.5 }, 0)

		return timeline
	},

	onContentLoaded(view) {
		// no-op for static view (content already in template)
	},
}
